<div [ngClass]="props.isAutoComplete ? 'autocomplete' : props.isSwitchInput === true ? 'form-check form-switch' : ''"
    *ngIf="!props.isHidden">

    <ng-container *ngIf="props.label">
        <label [ngClass]="{'font-size-14': props.field_Name === 'otp' || props.field_Name === 'userId'}">
          {{ props.label }} <span *ngIf="props.required">*</span>
        </label>
      </ng-container>

    <div [ngClass]="props.icon || props.infoicon ? 'input-group' : ''">
        <input type="{{ props.proptype }}" [ngClass]="props.infoicon ? 'border-right-0' : ''" id="{{ props.field_Name }}"
            formControlName="{{ props.field_Name }}" maxlength="{{ props.maxlength }}"
            placeholder="{{ props.infoicon ? '' : (props.placeholder || props.label) }}" name="{{ props.field_Name }}"
            minlength="{{ props.minlength }}" class="form-control" pattern="{{ props.custom }}" min="1"
            [readonly]="props.readOnly" smTrim />

        <div class="input-group-append" *ngIf="props.infoicon">
            <span class="input-group-text rounded-right" (click)="onIconClick()"
                [ngbPopover]="props.placeholder || 'Default Placeholder'" triggers="manual" #popoverRef="ngbPopover"
                placement="left">
                <img src="../../../../../../assets/images/siemens-assets/icon-i.svg" alt="info" class="input-img" />
            </span>
        </div>
        <div class="input-group-append" *ngIf="props.icon">
            <span class="input-group-text">
                <span class="input-user"></span>
            </span>
        </div>

    </div>
    <!-- <sm-error [control]="formcontrol"></sm-error> -->
    <div class="error-container">
        <sm-error [control]="formcontrol" [label]="'Field'"></sm-error>
    </div>

    <!-- <div class="error-message mx-3">
    </div> -->
</div>